module.exports = __webpack_public_path__ + "static/exp-c4d822a1f235a82d267f7b8084febb9b.jpeg";